import React from 'react';
import { motion } from 'framer-motion';
import { BellOff, BrainCircuit, Moon } from 'lucide-react';
export function MethodSection() {
  const steps = [{
    icon: <BellOff className="w-8 h-8 text-[#1B2141]" data-id="element-128" />,
    title: '1. Apagar Alarma',
    subtitle: '(Cuerpo)'
  }, {
    icon: <BrainCircuit className="w-8 h-8 text-[#1B2141]" data-id="element-129" />,
    title: '2. Desactivar Mente',
    subtitle: '(Pensamientos)'
  }, {
    icon: <Moon className="w-8 h-8 text-[#1B2141]" data-id="element-130" />,
    title: '3. Re-Entrada',
    subtitle: '(7 minutos)'
  }];
  return <section className="w-full bg-[#1B2141] py-20 px-6 md:px-8 text-[#FAF6F0]" data-id="element-131">
      <div className="max-w-5xl mx-auto" data-id="element-132">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-133">
          <h2 className="font-serif text-3xl md:text-5xl mb-4 text-[#FAF6F0]" data-id="element-134">
            El Mapa 3-Bloques
          </h2>
          <p className="text-xl text-[#C9A96E] font-medium" data-id="element-135">
            La razón por la que esto es diferente
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-136">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-0.5 bg-[#C9A96E]/30 z-0" data-id="element-137"></div>

          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="relative z-10 flex flex-col items-center" data-id="element-138">
              <div className="w-24 h-24 rounded-full bg-[#FAF6F0] flex items-center justify-center mb-6 shadow-lg border-4 border-[#C9A96E]" data-id="element-139">
                {step.icon}
              </div>
              <h3 className="font-serif text-2xl mb-2" data-id="element-140">{step.title}</h3>
              <p className="text-[#C9A96E] text-lg" data-id="element-141">{step.subtitle}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} className="text-center mt-16 max-w-2xl mx-auto" data-id="element-142">
          <p className="text-xl md:text-2xl leading-relaxed" data-id="element-143">
            A las 3 AM, tu mente quiere negociar. <br data-id="element-144" />
            <span className="text-[#C9A96E] font-serif italic" data-id="element-145">
              Este sistema evita la negociación.
            </span>
          </p>
          <p className="mt-4 text-[#FAF6F0]/70 text-lg" data-id="element-146">
            No te pide motivación. Te pide ejecución.
          </p>
        </motion.div>
      </div>
    </section>;
}